module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921045649_T.b46b0853.jpg";